import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Validate Your<br />
              Startup Idea
            </h1>
            <p className="hero-description">
              Get US$50,000 in funding to test your startup idea in 12 weeks.
              Join Decode Fellowship Program, the premier tech fellowship program that transforms
              ambitious entrepreneurs into successful founders.
            </p>
            <div className="hero-actions">
              <a href="https://forms.fillout.com/t/hHZE5TwMiuus" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-large">
                Join as a Fellow
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section section-accent">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Alumni Founded</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">$2.1B</div>
              <div className="stat-label">Total Raised</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">12</div>
              <div className="stat-label">Week Program</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">$50K</div>
              <div className="stat-label">Funding Provided</div>
            </div>
          </div>
        </div>
      </section>

      {/* Program Overview */}
      <section className="section">
        <div className="container">
          <div className="content-block">
            <h2 className="section-title">How Decode Fellowship Program Works</h2>
            <p className="section-subtitle">
              Our structured 12-week program takes you from idea to validated startup
              with funding, mentorship, and a global network of successful entrepreneurs.
            </p>
          </div>

          <div className="program-steps">
            <div className="step-item">
              <div className="step-number">01</div>
              <div className="step-content">
                <h3 className="step-title">Apply & Get Selected</h3>
                <p className="step-description">
                  Submit your application with your startup idea. Our team reviews applications
                  and selects the most promising entrepreneurs for interviews.
                </p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">02</div>
              <div className="step-content">
                <h3 className="step-title">Validate Your Idea</h3>
                <p className="step-description">
                  Work with experienced mentors to test your assumptions, build an MVP,
                  and validate your startup concept with real customers.
                </p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">03</div>
              <div className="step-content">
                <h3 className="step-title">Build & Scale</h3>
                <p className="step-description">
                  Develop your product, establish your go-to-market strategy,
                  and prepare for sustainable growth with ongoing support.
                </p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">04</div>
              <div className="step-content">
                <h3 className="step-title">Launch & Fundraise</h3>
                <p className="step-description">
                  Present at Demo Day to investors, join our alumni network,
                  and continue building your startup with ongoing resources.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fellowship Benefits */}
      <section className="section section-light">
        <div className="container">
          <div className="content-block">
            <h2 className="section-title">Join the Fractional Fellowship Community!</h2>
            <p className="section-subtitle">
              The Fractional Fellowship helps fractional founders transform their part-time project
              into high growth, venture-scalable and (eventually) full-time startups with bespoke support.
            </p>
          </div>

          <div className="benefits-grid">
            <div className="benefit-item">
              <h3 className="benefit-title">🗓️ Curriculum</h3>
              <p className="benefit-description">
                Fellows have access to personalized learning (based on time-tested curriculum from
                Berkeley and Stanford), and bespoke pop-up boards (with experienced operators) to
                validate and grow their idea.
              </p>
            </div>

            <div className="benefit-item">
              <h3 className="benefit-title">🤝 Community</h3>
              <p className="benefit-description">
                Fellows have access to intimate roundtable discussions with experienced founders,
                operators and investors.
              </p>
            </div>

            <div className="benefit-item">
              <h3 className="benefit-title">💰 Capital</h3>
              <p className="benefit-description">
                Fellows (per startup) can receive up to $1M in their next venture round, and other
                funding support (including intros to other investors and credits in software).
              </p>
            </div>
          </div>

          <div className="content-block" style={{ marginTop: '3rem' }}>
            <p className="section-subtitle">
              Applications are considered on a rolling basis.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonial */}
      <section className="section">
        <div className="container">
          <div className="testimonial-block">
            <blockquote className="testimonial-quote">
              "Decode Fellowship Program gave me the framework, mentorship, and confidence to turn my idea
              into a $10M company. The network alone is worth it."
            </blockquote>
            <div className="testimonial-author">
              <div className="author-name">Sarah Chen</div>
              <div className="author-title">Founder, TechFlow AI • Decode Fellowship Program Cohort 3</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-dark">
        <div className="container">
          <div className="cta-block">
            <h2 className="cta-title">Ready to Validate Your Startup Idea?</h2>
            <p className="cta-description">
              Join the next cohort of ambitious entrepreneurs. Applications are reviewed
              on a rolling basis.
            </p>
            <a href="https://forms.fillout.com/t/hHZE5TwMiuus" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-large">
              Join as a Fellow
            </a>
            <p className="cta-note">
              Next cohort starts January 2025 • Rolling applications
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;